import React from 'react';
import { CategoriesProxy } from '../services/catalogServiceAPI/categoriesProxy';
import { Link, withRouter } from 'react-router-dom';
import { Tabs, Tree, Button, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

export const TYPE_LABELS = {
    items: 'Items',
    room: 'Wall & Floors',
};

export const byPriorityThenTitle = (a, b) => {
    const diff = (a.priority || 0) - (b.priority || 0);
    if (diff !== 0) return diff;
    return (a.title || '').toLowerCase().localeCompare((b.title || '').toLowerCase());
};

function buildTreeData(flatCategories, type, baseUrl) {
    const all = flatCategories || [];
    if (!all.length) return [];
    const byId = {};
    all.forEach(cat => { byId[cat.id] = { ...cat, children: [] }; });
    all.forEach(cat => {
        if (cat.parentId && byId[cat.parentId]) {
            byId[cat.parentId].children.push(byId[cat.id]);
        }
    });

    function toTreeNode(node) {
        const sorted = node.children.slice().sort(byPriorityThenTitle);
        const isLeaf = sorted.length === 0;
        return {
            key: node.id,
            title: isLeaf
                ? <Link to={`${baseUrl}/category/${node.id}?title=${node.title}`}>{node.title}</Link>
                : <span>{node.title}</span>,
            children: isLeaf ? undefined : sorted.map(toTreeNode),
            isLeaf,
        };
    }

    return all
        .filter(cat => !cat.parentId && (cat.type || 'items') === type)
        .map(cat => byId[cat.id])
        .sort(byPriorityThenTitle)
        .map(toTreeNode);
}

class CategoriesComponent extends React.Component {
    categoriesProxy = new CategoriesProxy();
    state = { categories: [], loading: true };

    componentWillMount() {
        this.categoriesProxy.list()
            .then(categories => this.setState({ categories, loading: false }));
    }

    render() {
        const { categories, loading } = this.state;
        const baseUrl = this.props.match.url;

        const itemsTree = buildTreeData(categories, 'items', baseUrl);
        const roomTree = buildTreeData(categories, 'room', baseUrl);

        const tabItems = [
            {
                key: 'items',
                label: TYPE_LABELS.items,
                children: (
                    <Tree
                        treeData={itemsTree}
                        defaultExpandAll={false}
                        blockNode
                        style={{ background: 'transparent' }}
                    />
                ),
            },
            {
                key: 'room',
                label: TYPE_LABELS.room,
                children: (
                    <Tree
                        treeData={roomTree}
                        defaultExpandAll={false}
                        blockNode
                        style={{ background: 'transparent' }}
                    />
                ),
            },
        ];

        return (
            <div style={{ padding: 24, position: 'relative', minHeight: '100%' }}>
                <Spin spinning={loading}>
                    <Tabs items={tabItems} />
                </Spin>

                <Link to="catalog/create">
                    <Button
                        type="primary"
                        shape="circle"
                        icon={<PlusOutlined />}
                        size="large"
                        style={{
                            position: 'fixed',
                            bottom: 32,
                            right: 32,
                            width: 56,
                            height: 56,
                            fontSize: 24,
                            background: '#7b6ef6',
                            borderColor: '#7b6ef6',
                            boxShadow: '0 4px 16px rgba(123,110,246,0.5)',
                        }}
                    />
                </Link>
            </div>
        );
    }
}

export const Categories = withRouter(CategoriesComponent);
